import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { parseDate } from 'helpers/DateFormatter';
import { AddButton } from 'elements/CustomHeaderButtons/HeaderButtons';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import SearchBox from 'elements/SearchBox/SearchBox';
import DataTable from 'components/DataTable/DataTable';
import { redTableCellStyle } from 'components/DataTable/DataTable.styled';
import { updatedTabledefination } from './TestEquipment.constants';
import { searchTestEquipment, reSetTestTotalCount, setDeviceTypeSortOrder, setStatusSortOrder } from './TestEquipment.actions';
import { setDataForEditTestEquipment } from './AddEditTestEquipmentForm/TestEquipmentForm.actions';
import { checkOfflineDataPresent, setCurrentView } from '../Home/Home.actions';
import { NONMO_USER_ROLE } from '../Home/Home.constants';
import DropdownInput from '../Admin/elements/DropdownInput';

const TestEquipmentPage = (props) => {
  const { initializeTestEquipmentData } = props;
  const { setCurrentAppView, testEquipmentDataAll, testEquipmentTableData, triggerSearch,
    isTableLoading, isMRATOnline, isOfflineDataPresent, checkOfflineFormDataPresent,
    totalCount, searchStringForTestEq, setStatusSortAscOrder, setDeviceTypeSortAscOrder, previousScreen, IsLateEntry } = props;
  const [searchString, setSearchString] = useState(searchStringForTestEq);
  const [isNonMoFilter, setIsNonMoFilter] = useState('All');
  const tableData = searchString.length === 0 ? testEquipmentDataAll : testEquipmentTableData;
  const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);

  useEffect(() => {
    checkOfflineFormDataPresent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOfflineDataPresent, isMRATOnline]);

  const testEquipmentButtonHandler = () => {
    setCurrentAppView('addTestEquipmentform');
  };

  const now = new Date();
  const { redTableCell } = redTableCellStyle();

  const editButtonHandler = (rowdata) => {
    initializeTestEquipmentData(rowdata);
    setCurrentAppView('editTestEquipmentform');
  };
  const getParsedTableData = () => {
    let filteredData = tableData;
    if (isNonMoFeatureEnabled) {
      if (isNonMoFilter === 'Yes') {
        filteredData = filteredData.filter((item) => item.IsNonMoTrf === true);
      } else if (isNonMoFilter === 'No') {
        filteredData = filteredData.filter((item) => item.IsNonMoTrf === false);
      }
    }

    return filteredData.map((item) => {
      const nonMouserArrow = (isNonMoFeatureEnabled && item.IsNonMoTrf === false);
      return {
        ...item,
        CalDueDate: parseDate(`${item.CalDueDate}`),
        IsCellRedClass: (item.CalDueDate && new Date(item.CalDueDate).setHours(0, 0, 0, 0) < now.setHours(0, 0, 0, 0))
          ? redTableCell : null,
        FormDeviceType: item.DeviceType?.slice(0, 20),
        FormManufacturer: item.TestEqManufacturer?.slice(0, 20),
        FormModel: item.TestEqModel?.slice(0, 20),
        NonMo: isNonMoFeatureEnabled && (item.IsNonMoTrf ? 'Yes' : 'No'),
        HideArrow: (isMRATOnline && isOfflineDataPresent) || nonMouserArrow,
      };
    });
  };
  const handleSearch = (searchValue) => {
    setSearchString(searchValue);
    triggerSearch(searchValue);
  };

  const sortButtonHandler = (columnName) => {
    if (columnName === 'FormDeviceType') {
      setDeviceTypeSortAscOrder(columnName);
    } else {
      setStatusSortAscOrder(columnName);
    }
  };
  const headerText = () => {
    if (IsLateEntry) {
      return `${NONMO_USER_ROLE.LateEntryUser} Test Equipment Inventory`;
    }
    if (isNonMoFeatureEnabled) {
      return `${NONMO_USER_ROLE.User} Test Equipment Inventory`;
    }
    return 'Test Equipment Inventory';
  };
  return (
    <SiteWrapper
      headerText={headerText()}
      ButtonSection={!(isMRATOnline && isOfflineDataPresent) && <AddButton id="addButtonOfTest" buttonHandler={testEquipmentButtonHandler} />}
      showTotalCount
      totalCount={totalCount}
      goBack={previousScreen}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <SearchBox
                value={searchStringForTestEq}
                handleSearch={handleSearch}
                margin="5px"
                width="400px"
              />
              {isNonMoFeatureEnabled && (
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                  <span style={{ fontSize: '10pt', marginRight: '5px', fontWeight: 'bold' }}>
                    Is
                    {' '}
                    {NONMO_USER_ROLE.User}
                  </span>
                  <DropdownInput
                    style={{ width: '100px', marginRight: '5px' }}
                    value={isNonMoFilter}
                    options={['All', 'Yes', 'No']}
                    handleInputChange={(e) => {
                      setIsNonMoFilter(e.target.value);
                    }}
                  />
                </div>
              )}

            </div>
            <DataTable
              id="TestEquipmentDataTable"
              tableDefinition={updatedTabledefination(isNonMoFeatureEnabled)}
              tableData={getParsedTableData()}
              showArrowButton
              isLoading={isTableLoading}
              sortButtonHandler={sortButtonHandler}
              actionButtonHandler={(dataRow) => editButtonHandler(dataRow)}
            />
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

const mapStateToProps = ({ AppData, TestEquipment, Home }) => ({
  isMRATOnline: AppData.isMRATOnline,
  previousScreen: Home.previousScreen,
  isOfflineDataPresent: Home.isOfflineDataPresent,
  testEquipmentDataAll: TestEquipment.testEquipmentDataAll,
  testEquipmentTableData: TestEquipment.testEquipmentTableData,
  isTableLoading: TestEquipment.tableLoading || false,
  totalCount: TestEquipment.totalCount,
  searchStringForTestEq: TestEquipment.searchStringForTestEq,
  sortDeviceTypeAscOrder: TestEquipment.sortDeviceTypeAscOrder,
  sortStatusAscOrder: TestEquipment.sortStatusAscOrder,
  IsLateEntry: Home.IsLateEntry
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setCurrentAppView: (view) => dispatch(setCurrentView(view)),
  triggerSearch: (value) => dispatch(searchTestEquipment(value)),
  initializeTestEquipmentData: (rowdata) => dispatch(setDataForEditTestEquipment(rowdata)),
  resetTestTotalCount: () => { dispatch(reSetTestTotalCount()); },
  setDeviceTypeSortAscOrder: (columnName) => { dispatch(setDeviceTypeSortOrder(columnName)); },
  setStatusSortAscOrder: (columnName) => { dispatch(setStatusSortOrder(columnName)); },
  checkOfflineFormDataPresent: () => dispatch(checkOfflineDataPresent()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TestEquipmentPage);

TestEquipmentPage.propTypes = {
  checkOfflineFormDataPresent: PropTypes.func,
  initializeTestEquipmentData: PropTypes.func.isRequired,
  IsLateEntry: PropTypes.bool,
  isMRATOnline: PropTypes.bool.isRequired,
  isOfflineDataPresent: PropTypes.bool.isRequired,
  isTableLoading: PropTypes.bool,
  previousScreen: PropTypes.string,
  searchStringForTestEq: PropTypes.string,
  setCurrentAppView: PropTypes.func,
  setDeviceTypeSortAscOrder: PropTypes.func,
  setStatusSortAscOrder: PropTypes.func,
  testEquipmentDataAll: PropTypes.array.isRequired,
  testEquipmentTableData: PropTypes.array.isRequired,
  totalCount: PropTypes.number,
  triggerSearch: PropTypes.func.isRequired,
};
